
import Swiper from 'vux/src/components/swiper/swiper.vue'

export default {
components: {
Swiper
},
data() {
return {
list: [{
img: 'http://p1nz6cslc.bkt.clouddn.com/shops/5a38c608dd2e29c429ff2bda/28AC9B3ABD4FD3A62824E590F3776DEB.png'
},{
img: 'http://p1nz6cslc.bkt.clouddn.com/shops/5a38c608dd2e29c429ff2bda/assetMgrBackground2.png'
},{
img: 'http://p1nz6cslc.bkt.clouddn.com/shops/5a38c608dd2e29c429ff2bda/assetMgrBackground2.png'
},{
img: 'http://p1nz6cslc.bkt.clouddn.com/shops/5a38c608dd2e29c429ff2bda/assetMgrBackground2.png'
},{
img: 'http://p1nz6cslc.bkt.clouddn.com/shops/5a38c608dd2e29c429ff2bda/assetMgrBackground2.png'
},{
img: 'http://p1nz6cslc.bkt.clouddn.com/shops/5a38c608dd2e29c429ff2bda/assetMgrBackground2.png'
}]
}
},
props: ['data'],
mounted() {

},
computed: {
images() {
let arr = [];
let images = this.data;
for (let i = 0; i < images.length; i++) {
arr.push({
url: '',
img: process.env.UPLOAD_DOMAIN + images[i]
})
};
console.log(arr)
return arr;
}
}
}



// WEBPACK FOOTER //
// ./src/components/Detail/Swiper.vue